export default function PHP_getName() {
  return (
    <div>
      <h1>PHP_getName</h1>
    </div>
  );
}
